export const notImplementedAlert = () => {
  alert("Under construction. Exciting things coming soon!");
};
